<template>
  <el-container direction="vertical" id="insureManagement">
    <el-row class="row-bg">
      <!-- 头部 -->
      <el-header>
        <el-col :span="24" style="text-align: center">
          <div>
            <span class="p-title">{{dynamicValidateForm.projectName}}</span>
          </div>
        </el-col>
        <el-col :span="14" :push="5" class="my-step">
          <el-steps :active="0" align-center>
            <el-step title="选择投保方案"></el-step>
            <el-step title="填写投保信息"></el-step>
            <el-step title="在线支付"></el-step>
            <el-step title="完成投保"></el-step>
          </el-steps>
        </el-col>
      </el-header>
    </el-row>
    <el-main>
      <!-- 表单计划 -->
      <el-row>
        <el-col :span="16" :push="4">
          <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="204px" class="demo-dynamic" style="text-align: left">
            <el-card class="box-card">
              <div class="box-card-div-title userInfo"><div class="header">投保计划</div></div>
              <el-form-item>
                <el-button :class="dynamicValidateForm.planId === plan.id ? 'true' : 'false'" style="width: 200px;min-width: 144px;border: 0px"
                           v-for="plan in dynamicValidateForm.planList" :key="plan.id" @click="planChange(plan.id)"> {{$$.isValidObj(plan.name) ? plan.name : '默认'}}
                </el-button>
              </el-form-item>
            </el-card>
            <el-card class="box-card">
              <div class="box-card-div-title userInfo"><div class="header">基础信息</div></div>
              <el-form-item :label="baseSpec.name" class="form-item-label" :key="baseSpec.name" v-for="baseSpec in dynamicValidateForm.baseSpecList">
                <el-input class="form-item-input my-input-left" :disabled="true"
                          :value="baseSpec.specName"></el-input>
              </el-form-item>
              <el-form-item label="投保单位" class="form-item-label">
                <el-input class="form-item-input my-input-left" style="width: calc(100% - 35px);min-width: 144px"
                          v-model="dynamicValidateForm.companyName"
                          placeholder="请填写与营业执照上一致的单位名称（必填）"
                ></el-input>
              </el-form-item>
            </el-card>
            <el-card class="box-card"
                     v-for="(card, index) in dynamicValidateForm.cards"
                     :key="card.key"
            >
              <div class="box-card-div">
                <div class="box-card-div-title supportPlan"><div class="header">{{'保障计划' + $$.changeNumToHan(index + 1) }}</div></div>
                <span v-if="index !== 0">
                  <el-button class="header-button-delete" @click.prevent="removeDomain(card)">删除计划</el-button>
                  <el-button class="header-button-Take" @click.prevent="takeInPlan(card, $event)">收起</el-button>
                </span>
              </div>
              <p style="color: #fa6b4b;font-size: 1rem;margin-bottom: 10px;">说明：同一保障计划只能投保一种职业，多个职业需对应添加保障计划</p>
              <div :id="card.key">
                <el-form-item
                  class="form-item-label"
                  :label= "$$.isValidObj(dynamicValidateForm.skuSpecList) ? dynamicValidateForm.skuSpecList[2].name : '职业'"
                  :rules="[{
                            required: true,
                            message: '请选择职业',
                            trigger: 'blur'
                          }]"
                >
                  <el-select @change="occOneChange(index)" v-model="card.occOneId" placeholder="请选择"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item  in dynamicValidateForm.occOneList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-select @change="occTwoChange(index)" v-model="card.occTwoId" placeholder="请选择"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in card.occTwoList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                  <el-select @change="occThreeChange(index)" v-model="card.occThreeId" placeholder="请选择"
                             class="form-item-input my-input">
                    <el-option
                      v-for="item in card.occThreeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item-label"
                              :label="'职业代码'">
                  <div class="form-item-input my-input" style="width: 200px;">{{card.realityOccCode || '&nbsp;'}}</div>
                </el-form-item>
                <el-form-item class="form-item-label"
                              :label="'职业类别'">
                  <div class="form-item-input my-input" style="width: 200px;">{{$$.isValidObj(card.azcnCode) ? card.azcnCode+'类' : '&nbsp;'}}</div>
                </el-form-item>
                <el-form-item
                  class="form-item-label"
                  :label="'人数'"
                  :rules="[
                            { required: true, message: '请输入本计划投保人数', trigger: 'blur' }
                          ]"
                >
                  <el-input class="form-item-input my-input"
                            style="width: 200px"
                            v-model="card.groupSize"
                            @input="groupSizeChange($event)"
                            placeholder="请输入本计划投保人数"></el-input>
                </el-form-item>

                <el-form-item v-for="(action, i) in dynamicValidateForm.actionSpeList" :key=i :label= "action.name" class="form-item-label special"
                              :rules="[
                            { required: true, message: '请选择' + action.name, trigger: 'blur' }
                          ]"
                >
                    <el-select v-model="card.skuSpecNameList[action.name]" placeholder="请选择" class="form-item-input my-input"
                               @change="getChangeEvent(index, action.name)">
                      <el-option
                        v-for="item in card.skuSpecValueList[action.name]"
                        :key="item.id"
                        :label="item.specName"
                        :value="item.specName">
                      </el-option>
                    </el-select>
                </el-form-item>
              </div>
            </el-card>
            <el-form-item class="functionBlocks" style="text-align: right">
              <el-button @click="addDomain" class="header-button-add">添加保障计划</el-button>
              <el-button type="primary" @click="handlerSaveQuoteMain" class="header-button-save">{{generateName}}</el-button>
              <el-button @click="insureOrder" class="header-button-order">立即投保</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <!-- 产品详情 -->
      <el-row type="flex" justify="center" style="padding-bottom: 80px">
        <el-col :span="16">
          <template>
            <el-tabs v-model="activeName">
              <el-tab-pane label="产品简介" name="first" v-html="insuranceInfo.unscramble"></el-tab-pane>
              <el-tab-pane label="投保须知" name="second" v-html="insuranceInfo.ensureExplainContent"></el-tab-pane>
              <el-tab-pane label="理赔服务" name="third" v-html="insuranceInfo.claimsServices"></el-tab-pane>
              <el-tab-pane label="常见问题" name="four" v-html="insuranceInfo.commonProblem"></el-tab-pane>
            </el-tabs>
          </template>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>

<script type="text/javascript">

import {Loading} from 'element-ui';

export default {
    name: "insureManagement",
    data() {
      return {
        dynamicValidateForm: {
          cards: [{
            groupSize: '',
            occId: '',
            realityOccCode: '',
            //-- 职业参数
            occOneId: '',
            occTwoList: [],
            occTwoId: '',
            occThreeList: [],
            occThreeId: '',
            occOneName: '',
            occTwoName: '',
            occThreeName: '',
            //职业id
            occupationId: 0,
            //职业类别
            azcnCode: '',
            //取值获取规格值下拉选项
            pid: 0,
            topLevelId: 0,
            skuInfo: {},
            skuSpecValueList: {},
            skuSpecNameList: {}
          }],
          companyName: '',
          occOneList: [],
          //-- sku参数
          skuSpecList: [],
          skuRelationAddList: [],
          occupationList: [],
          projectName: '',
          baseSpecList: [],
          actionSpeList: [],
          skuBaseTitle: "",
          planList: [],
        },
        generateName: '生成报价书',
        activeName: 'first',
        insuranceInfo: {
          unscramble:'',
          ensureExplainContent:'',
          claimsServices:'',
          commonProblem:''
        },
        productId:'',
        planId:''
      };
    },
    methods: {
      //-- 点击计划时
      planChange(id){
        if( this.dynamicValidateForm.planId === id ){
          return
        }
        const newUrl = "/#"+this.$route.path + "?productId=" + this.dynamicValidateForm.productId + "&planId=" + id;
        window.history.replaceState('', '', newUrl);
        this.$route.query.planId = id;
        this.dynamicValidateForm.planId = id;
        this.dynamicValidateForm.cards.forEach(item => {
          item.groupSize = '';
          item.occId = '';
          item.realityOccCode = '';
          //-- 职业参数
          item.occOneId = '';
          item.occTwoList = [];
          item.occTwoId = '';
          item.occThreeList = [];
          item.occThreeId = '';
          item.occOneName = '';
          item.occTwoName = '';
          item.occThreeName = '';
          //职业id
          item.occupationId = 0;
          //职业类别
          item.azcnCode = '';
          //取值获取规格值下拉选项
          item.pid = 0;
          item.topLevelId = 0;
          item.skuInfo = {};
          item.skuSpecValueList = {};
          item.skuSpecNameList = {};
        });
        this.getSkuInfo();
      },
      takeInPlan(item, event) {
        let key = document.getElementById(item.key),
          el = event.currentTarget;

        if (this.$$.isValidObj(key)){
          !key.hasAttribute("hidden") ?
            key.setAttribute("hidden", "hidden") :
            key.removeAttribute("hidden");
        } else {

        }

        el.innerHTML = el.innerHTML.includes('收起') ? '展开' : '收起';
      },
      removeDomain(item) {
        const index = this.dynamicValidateForm.cards.indexOf(item);
        if (index !== -1) {
          this.dynamicValidateForm.cards.splice(index, 1)
        }
      },
      addDomain() {
        if (this.dynamicValidateForm.cards.length > 9) {
          this.$message.error("保障计划最多添加10个!");
        } else {
          this.dynamicValidateForm.cards.push({
            groupSize: '',
            occId: '',
            realityOccCode: '',
            //-- 职业参数
            occOneId: '',
            occTwoList: [],
            occTwoId: '',
            occThreeList: [],
            occThreeId: '',
            occOneName: '',
            occTwoName: '',
            occThreeName: '',
            //职业id
            occupationId: 0,
            //职业类别
            azcnCode: '',
            //取值获取规格值下拉选项
            pid: 0,
            topLevelId: 0,
            skuInfo: {},
            skuSpecValueList: {},
            skuSpecNameList: {},
            key: Date.now()
          });
          this.dynamicValidateForm.actionSpeList.forEach(item => {
            this.dynamicValidateForm.cards[this.dynamicValidateForm.cards.length-1].skuSpecNameList[item.name] = "";
            this.dynamicValidateForm.cards[this.dynamicValidateForm.cards.length-1].skuSpecValueList[item.name] = "";
          });

        }
      },
      //-- 获取 - 产品详情
      getInsurance(productId) {
        this.axios.post('/management/mobileInsuranceInfo/getInsurance?insuranceInfoId='+productId).then((response) => {
          if(response.data.success){
            const {claimsServices, commonProblem, ensureExplainContent, unscramble, projectName} = response.data.datas;
            this.insuranceInfo = {
              unscramble,
              ensureExplainContent,
              claimsServices,
              commonProblem
            };
            if (this.$$.isValidObj(projectName)) this.dynamicValidateForm.projectName = projectName;
          }else {
            this.$message.error(response.data.msg);
            this.$router.push({name: 'index'});
          }
        })
      },
      //-- 当选择第一个职业
      occOneChange(index) {
        this.$forceUpdate();
        this.dynamicValidateForm.occOneList.forEach(item => {
          item.id === this.dynamicValidateForm.cards[index].occOneId ? this.dynamicValidateForm.cards[index].occTwoList = item.children : [];
          item.id === this.dynamicValidateForm.cards[index].occOneId ? this.dynamicValidateForm.cards[index].occOneName = item.name : '';
        });
        this.dynamicValidateForm.cards[index].skuInfo = {};
        this.dynamicValidateForm.cards[index].occTwoId = '';
        this.dynamicValidateForm.cards[index].occThreeId = '';
        this.dynamicValidateForm.cards[index].occThreeList = [];
        this.dynamicValidateForm.cards[index].realityOccCode = '';
        this.dynamicValidateForm.cards[index].azcnCode = '';
        this.dynamicValidateForm.cards[index].occThreeName = '';
        this.dynamicValidateForm.cards[index].occTwoName = '';
        this.dynamicValidateForm.cards[index].occId = '';
      },
      //-- 当选择第二个职业
      occTwoChange(index) {
        this.$forceUpdate();
        this.dynamicValidateForm.cards[index].occTwoList.forEach(item => {
          item.id === this.dynamicValidateForm.cards[index].occTwoId ? this.dynamicValidateForm.cards[index].occThreeList = item.children : [];
          item.id === this.dynamicValidateForm.cards[index].occTwoId ? this.dynamicValidateForm.cards[index].occTwoName = item.name : '';
        });
        this.dynamicValidateForm.cards[index].skuInfo = {};
        this.dynamicValidateForm.cards[index].occThreeId = '';
        this.dynamicValidateForm.cards[index].realityOccCode = '';
        this.dynamicValidateForm.cards[index].azcnCode = '';
        this.dynamicValidateForm.cards[index].occThreeName = '';
        this.dynamicValidateForm.cards[index].occId = '';
      },
      //-- 当选择第三个职业
      occThreeChange(index) {
        this.$forceUpdate();
        this.dynamicValidateForm.cards[index].occupationId = 0;
        this.dynamicValidateForm.cards[index].occThreeList.forEach(item => {
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].occId = item.id : '';
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].azcnCode = item.azcnCode : '';
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].occThreeName = item.name : '';
          item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].realityOccCode = item.realityOccCode : '';
        });
        this.dynamicValidateForm.occupationList.forEach(item => {
          if (this.dynamicValidateForm.cards[index].occupationId == 0) this.dynamicValidateForm.cards[index].occupationId = item.specValue == this.dynamicValidateForm.cards[index].azcnCode ? item.id : 0;
        });
        this.dynamicValidateForm.cards[index].skuInfo = {};
        this.dynamicValidateForm.skuRelationAddList.forEach(item => {
          if (item.id == this.dynamicValidateForm.cards[index].occupationId) {
            this.dynamicValidateForm.cards[index].pid = item.id;
            this.dynamicValidateForm.cards[index].topLevelId = item.pid;
            return;
          }
        });

        this.dynamicValidateForm.cards[index].skuSpecNameList = {};
        this.dynamicValidateForm.cards[index].skuSpecValueList = {};
        this.dynamicValidateForm.actionSpeList.forEach(item => {
          this.dynamicValidateForm.cards[index].skuSpecNameList[item.name] = "";
          this.dynamicValidateForm.cards[index].skuSpecValueList[item.name] = "";
        });
        let list = [];
        this.dynamicValidateForm.cards[index].skuSpecValueList = {};
        this.dynamicValidateForm.cards[index].skuSpecNameList = {};
        this.dynamicValidateForm.skuRelationAddList.forEach(item => {
          if (item.pid == this.dynamicValidateForm.cards[index].pid && item.topLevelId == this.dynamicValidateForm.cards[index].topLevelId) {
            let json = {};
            json['id'] = item.id;
            json['specName'] = item.name;
            json['topLevelId'] = item.pid;
            list.push(json);
            return;
          }
        });
        this.dynamicValidateForm.cards[index].skuSpecValueList[this.dynamicValidateForm.actionSpeList[0].name] = list;
      },
      getChangeEvent(i, name){
        this.$forceUpdate();

        let num = 0;

        for (let skuSpecValueListKey in this.dynamicValidateForm.cards[i].skuSpecValueList) {
          if ( skuSpecValueListKey !== name ){
            num++;
          }else {
            this.dynamicValidateForm.cards[i].skuSpecValueList[name].forEach(item => {
              if( item.specName ===  this.dynamicValidateForm.cards[i].skuSpecNameList[name]) {
                this.dynamicValidateForm.cards[i].pid = item.id;
                this.dynamicValidateForm.cards[i].topLevelId = item.topLevelId;
              }
            });
            break;
          }
        }

        for (let j = num+1; j < this.dynamicValidateForm.actionSpeList.length; j++) {
          this.dynamicValidateForm.cards[i].skuSpecNameList[this.dynamicValidateForm.actionSpeList[j].name] = "";
          this.dynamicValidateForm.cards[i].skuSpecValueList[this.dynamicValidateForm.actionSpeList[j].name] = "";
        }

        let list = [];
        let dataTitle = this.dynamicValidateForm.skuBaseTitle + this.dynamicValidateForm.cards[i].azcnCode + '类-';
        for (let skuSpecNameListKey in this.dynamicValidateForm.cards[i].skuSpecNameList) {
          if( this.$$.isValidObj(this.dynamicValidateForm.cards[i].skuSpecNameList[skuSpecNameListKey]) )
            dataTitle += this.dynamicValidateForm.cards[i].skuSpecNameList[skuSpecNameListKey] + "-";
        }

        dataTitle = dataTitle.substring(0, dataTitle.length-1);

        this.dynamicValidateForm.skuRelationAddList.forEach(item => {
          if (item.pid == this.dynamicValidateForm.cards[i].pid && item.topLevelId == this.dynamicValidateForm.cards[i].topLevelId && item.remarks.indexOf(dataTitle) != -1) {
            let json = {};
            json['id'] = item.id;
            json['specName'] = item.name;
            json['topLevelId'] = item.pid;
            list.push(json);
            return;
          }
        });

        if( this.dynamicValidateForm.actionSpeList.length !== num+1 ) this.dynamicValidateForm.cards[i].skuSpecValueList[this.dynamicValidateForm.actionSpeList[num+1].name] = list;

        if( this.dynamicValidateForm.actionSpeList.length === num+1 ) {
          let params = {};
          let skuSpec = [];
          skuSpec.push(dataTitle);
          params.insuranceInfoId = this.dynamicValidateForm.productId;
          params.planId = this.dynamicValidateForm.planId;
          params.skuSpec = skuSpec;
          this.axios.post('/management/mobileInsuranceInfo/getskuSpecRateInfo', this.qs.stringify(params,{indices: false})).then((response) => {
            let data = response.data;
            if( data.success ){
              this.dynamicValidateForm.cards[i].skuInfo = data.data[0];
            }
          });
        }
      },
      getSkuInfo() {
        let loadingInstance = Loading.service({fullscreen: true});
        this.axios.post('/management/mobileInsuranceInfo/getInsuranceSkuDetail?insuranceInfoId=' + this.dynamicValidateForm.productId + '&planId=' + this.dynamicValidateForm.planId, {}).then((response) => {
          let data = response.data;
          if (data.success) {
            let skuData = JSON.parse(data.skuData[0]);
            this.dynamicValidateForm.planList = data.planList;
            this.dynamicValidateForm.occOneList = data.occupationList;
            this.dynamicValidateForm.skuRelationAddList = skuData.skuRelationAddList;
            this.dynamicValidateForm.skuSpecList = data.datas.skuSpecList[this.dynamicValidateForm.planId];

            this.dynamicValidateForm.baseSpecList = [];
            this.dynamicValidateForm.skuBaseTitle = "";
            this.dynamicValidateForm.actionSpeList = [];
            this.dynamicValidateForm.skuSpecList.forEach(item => {
              let map = {};
              if(item.value[0].type === 6 || item.value[0].type === 1){
                map.name = item.name;
                map.specName = item.value[0].specName;
                this.dynamicValidateForm.skuBaseTitle += map.specName + "-";
                this.dynamicValidateForm.baseSpecList.push(map);
              }else if( item.value[0].type === 4 ){
                map.name = item.name;
                map.specName = item.value[0].specValue + "-" + item.value[item.value.length - 1].specValue + "类";
                this.dynamicValidateForm.baseSpecList.push(map);
              }else {
                map.name = item.name;
                this.dynamicValidateForm.actionSpeList.push(map);
              }
            });

            if( !this.$$.isValidObj(this.dynamicValidateForm.cards[0].skuSpecNameList) ){
              this.dynamicValidateForm.cards[0].skuSpecNameList = {};
              this.dynamicValidateForm.cards[0].skuSpecValueList = {};
              this.dynamicValidateForm.actionSpeList.forEach(item => {
                this.dynamicValidateForm.cards[0].skuSpecNameList[item.name] = "";
                this.dynamicValidateForm.cards[0].skuSpecValueList[item.name] = "";
              });
            }

            this.dynamicValidateForm.occupationList = this.dynamicValidateForm.skuSpecList[2].value;

            if (this.dynamicValidateForm.quoteMainNum) {
              this.dynamicValidateForm.cards.forEach(o => {
                this.dynamicValidateForm.occOneList.forEach(item => {
                  item.id === o.occOneId ? o.occTwoList = item.children : [];
                  item.id === o.occOneId ? o.occOneName = item.name : '';
                  return;
                });
              });
              this.dynamicValidateForm.cards.forEach((o, index) => {
                this.dynamicValidateForm.cards[index].occTwoList.forEach(item => {
                  item.id === o.occTwoId ? o.occThreeList = item.children : [];
                  item.id === o.occTwoId ? o.occTwoName = item.name : '';
                  return;
                });
              });
              this.dynamicValidateForm.cards.forEach((o, index) => {
                this.dynamicValidateForm.cards[index].occupationId = 0;
                this.dynamicValidateForm.cards[index].occThreeList.forEach(item => {
                  item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].occId = item.id : '';
                  item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].azcnCode = item.azcnCode : '';
                  item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].occThreeName = item.name : '';
                  item.id === this.dynamicValidateForm.cards[index].occThreeId ? this.dynamicValidateForm.cards[index].realityOccCode = item.realityOccCode : '';
                  return;
                });

                this.dynamicValidateForm.occupationList.forEach(item => {
                  if (this.dynamicValidateForm.cards[index].occupationId === 0) this.dynamicValidateForm.cards[index].occupationId = item.specValue === this.dynamicValidateForm.cards[index].azcnCode ? item.id : 0;
                });

                this.dynamicValidateForm.skuRelationAddList.forEach(item => {
                  if (item.id === this.dynamicValidateForm.cards[index].occupationId) {
                    this.dynamicValidateForm.cards[index].pid = item.id;
                    this.dynamicValidateForm.cards[index].topLevelId = item.pid;
                    return;
                  }
                });

                let dataTitle = this.dynamicValidateForm.skuBaseTitle + o.azcnCode + '类';
                let num = 0;

                this.axios.post('/management/skuproduct/'+this.dynamicValidateForm.cards[index].skuId).then((response) => {
                  let data = response.data;
                  if( data.success ){
                    this.dynamicValidateForm.cards[index].skuInfo = data.datas;

                    this.dynamicValidateForm.skuRelationAddList.forEach(item => {
                      if (item.pid === this.dynamicValidateForm.cards[index].pid && item.topLevelId === this.dynamicValidateForm.cards[index].topLevelId  && item.remarks.indexOf(dataTitle) != -1) {
                        let json = {};
                        json['id'] = item.id;
                        json['specName'] = item.name;
                        json['topLevelId'] = item.pid;
                        if ((this.dynamicValidateForm.cards[index].skuInfo.title + '').toString().indexOf(item.name) !== -1) {
                          dataTitle += "-" + item.name;
                          this.dynamicValidateForm.cards[index].pid = item.id;
                          this.dynamicValidateForm.cards[index].topLevelId = item.pid;
                          o.skuSpecNameList[this.dynamicValidateForm.actionSpeList[num].name] = item.name;
                          num++;
                        }
                        return;
                      }
                    });

                    this.dynamicValidateForm.skuRelationAddList.forEach(item => {
                      if (item.id === this.dynamicValidateForm.cards[index].occupationId) {
                        this.dynamicValidateForm.cards[index].pid = item.id;
                        this.dynamicValidateForm.cards[index].topLevelId = item.pid;
                        return;
                      }
                    });

                    let list = [];
                    this.dynamicValidateForm.skuRelationAddList.forEach(item => {
                      if (item.pid == this.dynamicValidateForm.cards[index].pid && item.topLevelId == this.dynamicValidateForm.cards[index].topLevelId) {
                        let json = {};
                        json['id'] = item.id;
                        json['specName'] = item.name;
                        json['topLevelId'] = item.pid;
                        list.push(json);
                        return;
                      }
                    });
                    this.dynamicValidateForm.cards[index].skuSpecValueList[this.dynamicValidateForm.actionSpeList[0].name] = list;


                    dataTitle = this.dynamicValidateForm.skuBaseTitle + o.azcnCode + '类';
                    this.dynamicValidateForm.actionSpeList.forEach((item,i) => {
                      list = [];
                      if( i !== this.dynamicValidateForm.actionSpeList.length-1 ){
                        dataTitle += "-" + o.skuSpecNameList[item.name];
                        this.dynamicValidateForm.cards[index].skuSpecValueList[item.name].forEach(spec => {
                          if( spec.specName === o.skuSpecNameList[item.name]){
                            this.dynamicValidateForm.cards[index].pid = spec.id;
                            this.dynamicValidateForm.cards[index].topLevelId = spec.topLevelId;
                          }
                        });
                        this.dynamicValidateForm.skuRelationAddList.forEach(item => {
                          if(item.pid === this.dynamicValidateForm.cards[index].pid && item.topLevelId === this.dynamicValidateForm.cards[index].topLevelId  && item.remarks.indexOf(dataTitle) != -1){
                            let json = {};
                            json['id'] = item.id;
                            json['specName'] = item.name;
                            json['topLevelId'] = item.pid;
                            list.push(json);
                            return;
                          }
                        });
                        o.skuSpecValueList[this.dynamicValidateForm.actionSpeList[i+1].name] = list;
                      }
                    });
                  }
                  this.$forceUpdate();
                });
              });
            }
            this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
          }
        });
      },
      //-- 报价书数据拼接
      quoteMainData() {
        // -- 主数据
        let quoteMainData = {};
        // -- 计划数据
        let ensurePlan = {};
        let skuIds = '';
        quoteMainData.productId = this.dynamicValidateForm.productId;
        quoteMainData.planId = this.dynamicValidateForm.planId;
        quoteMainData.companyName = this.dynamicValidateForm.companyName.trim();
        this.dynamicValidateForm.cards.forEach((item, index) => {
          // -- ensurePlan内部数据
          let map = {};
          // -- 报价书表格数据
          let ensurePlanName = {};
          skuIds += item.skuInfo.id + ",";
          // -- 总保额
          map.coverage = 0;
          for (let skuSpecNameListKey in item.skuSpecNameList) {
            if( item.skuSpecNameList[skuSpecNameListKey].indexOf("万") !== -1 ){
              map.coverage += parseInt(item.skuSpecNameList[skuSpecNameListKey].replace("万", '') + '000');
            }
          }
          // -- 人数
          map.groupSize = item.groupSize;
          // -- 计划SkuId
          map.skuId = item.skuInfo.id;
          // -- 职业Id
          map.occId = item.occId;
          // -- 职业名称
          map.planOccName = item.occThreeName;
          // -- 职业代码
          map.azcnCode = item.azcnCode;

          let i = 0;

          for (let skuSpecNameListKey in item.skuSpecNameList) {
            let ensurePlanNameMap = {};
            ensurePlanNameMap.name = skuSpecNameListKey;
            ensurePlanNameMap.specName = item.skuSpecNameList[skuSpecNameListKey];
            ensurePlanName[i] = ensurePlanNameMap;
            i = i + 1;
          }
          map.ensurePlanName = JSON.stringify(ensurePlanName);
          ensurePlan[index] = map;
        });
        skuIds = skuIds.slice(0, skuIds.length - 1);
        quoteMainData.skuId = skuIds;
        quoteMainData.ensurePlan = JSON.stringify(ensurePlan);
        return quoteMainData;
      },
      //-- 报价书生成
      handlerSaveQuoteMain() {

        if (!this.dataIsValid()) {
          return;
        }

        let quoteMainData = this.quoteMainData();
        let loadingInstance = Loading.service({fullscreen: true});
        this.axios.post('/management/quotemaininfo/insertQuoteMainInfo', quoteMainData).then((response) => {
          if (response.data.success) {
            this.quoteMainSuccess(response.data);
          } else {
            this.$message.error(response.data.msg);
          }
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
      },
      // -- 数据校验
      dataIsValid() {
        let isValid = true;
        const reg = /^\d+$/;
        if (!this.dynamicValidateForm.companyName.trim()) {
          this.$message.error("投保单位不能为空!");
          return isValid = false;
        }
        try {
          this.dynamicValidateForm.cards.forEach((item, index) => {
            if (!this.$$.isValidObj(item.groupSize) || item.groupSize <= 0) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的投保人数不能为空!");
            }
            if (!reg.test(item.groupSize)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的投保人数只能填写数字!");
            }
            if (!this.$$.isValidObj(item.occId)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的职业不能为空!");
            }
            if (!this.$$.isValidObj(item.realityOccCode)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的职业代码不能为空!");
            }
            if (!this.$$.isValidObj(item.azcnCode)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的职业类别不能为空!");
            }
            if (!this.$$.isValidObj(item.skuInfo.id)) {
              throw new Error("保障计划" + this.$$.changeNumToHan(index + 1) + "的保障项目不能为空!");
            }
            this.dynamicValidateForm.cards.forEach((j, i) => {
              if (i !== index && item.skuSpecNameList === j.skuSpecNameList && item.occThreeId === j.occThreeId
              ) {
                throw new Error("存在职业和保障项目相同的计划,请重试!");
              }
            });
          });
        } catch (e) {
          this.$message.error(e.message);
          return isValid = false;
        }

        return isValid;
      },
      //-- 报价书生成成功跳转页面
      quoteMainSuccess(map) {
        sessionStorage.setItem('params', JSON.stringify(map));
        this.$router.push({name: 'quoteMainSaveSuccess'});
      },
      //-- 立即投保跳转
      insureOrder() {

        if (!this.dataIsValid()) {
          return;
        }

        let quoteMainData = this.quoteMainData();

        let loadingInstance = Loading.service({fullscreen: true});
        this.axios.post('/management/quotemaininfo/insertQuoteMainInfo_validation', quoteMainData).then((response) => {
          if (response.data.success) {
            sessionStorage.setItem('dynamicValidateForm', JSON.stringify(this.dynamicValidateForm));
            sessionStorage.removeItem('allData'); // 清理填写资料缓存
            this.$router.push({name: 'insureDetails', query:{productId: this.dynamicValidateForm.productId, planId: this.dynamicValidateForm.planId}});
          } else {
            this.$message.error(response.data.msg);
          }
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
      },
      groupSizeChange (e) {
        this.$forceUpdate()
      },
    },
    mounted() {
      if (!this.$$.checkLogin()){
        this.$confirm('当前订单参数错误，请重新进入~', '温馨提示：', {
          showClose: false,
          closeOnClickModal: false,
          center: true,
          showCancelButton: false,
          confirmButtonText: '确认',
        }).then(() => {
          this.$router.push({name: 'quotationManagement'});
        });
        return false;
      }
      this.getInsurance(this.$route.query.productId);
      let dynamicValidateForm = sessionStorage.getItem('dynamicValidateForm');

      if (this.$$.isValidObj(dynamicValidateForm)){
        dynamicValidateForm = JSON.parse(dynamicValidateForm);

        if (this.$$.isValidObj(dynamicValidateForm.quoteMainNum)) {
          this.generateName = '生成新的报价书';
          this.dynamicValidateForm.companyName = dynamicValidateForm.companyName;
          this.dynamicValidateForm.quoteMainNum = dynamicValidateForm.quoteMainNum;
          this.dynamicValidateForm.quoteMainId = dynamicValidateForm.quoteMainId;
          this.dynamicValidateForm.projectName = dynamicValidateForm.projectName;

          dynamicValidateForm.cards.forEach((item, index) => {
            if (this.dynamicValidateForm.cards.length < index + 1) {
              this.dynamicValidateForm.cards[index] = JSON.parse(JSON.stringify(this.dynamicValidateForm.cards[0]));
            }
            this.dynamicValidateForm.cards[index].groupSize = item.groupSize;
            this.dynamicValidateForm.cards[index].occOneId = item.occOneId;
            this.dynamicValidateForm.cards[index].occTwoId = item.occTwoId;
            this.dynamicValidateForm.cards[index].occThreeId = item.occThreeId;
            this.dynamicValidateForm.cards[index].skuId = item.skuId;
          });

        }else {
          this.dynamicValidateForm = dynamicValidateForm;
        }
      }
      this.dynamicValidateForm.productId = parseInt(this.$route.query.productId);
      this.dynamicValidateForm.planId = parseInt(this.$route.query.planId);
      this.getSkuInfo();
    },
    updated() {

      let length = 0, skuSpecList = this.dynamicValidateForm.skuSpecList;
      for (let i in skuSpecList){
        if (length < skuSpecList[i].name.length) length = skuSpecList[i].name.length;
      }
      $('.form-item-label .el-form-item__label').css('width', `${length*18}px`);
      $('.form-item-label .el-form-item__content').css('margin-left', `${length*18}px`);
    }
  }

</script>

<style scoped>

  .header-left {
    text-align: left !important;
  }

  .box-card {
    width: auto;
    height: auto;
    padding: 20px;
    margin-bottom: 2.5rem;
  }

  .box-card-div{
    position: relative;
  }

  .box-card-div-title {
    height: 12px;
    background: #FFBF00;
    font-size: 24px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 10px;
    display: inline-block;
    position: relative;
  }

  .box-card-div>span{
    position: absolute;
    right: 0;
    top: -20px;
  }

  .box-card-div-title.userInfo{
    width: 96px;
  }

  .supportPlan{
    width: 120px;
  }

  .box-card-div-title>.header{
    text-align: center;
    position: absolute;
    left: 0;
    top: -20px;
  }

  .box-card-div>span {
    display: inline-block;
  }

  .form-item-label {
    font-weight: 500;
    color: #333333;
    position: relative;
    /*display: flex;*/
  }

  .form-item-input {
    height: 40px;
    width: 144px;
    max-width: 640px;
    background: #F7F7F7;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }
  span.form-item-input {
    display: inline-block;
    background: #ffffff;
  }

  .header-content {
    text-align: center;
  }

  .p-title {
    font-size: 2.5rem;
    color: #333333;
    font-weight: bold;
    font-style: italic;
  }

  .row-bg {
    padding: 60px 0 40px;
  }

  .header-button-delete {
    height: 40px;
    color: #FFFFFF !important;
    background: #A51D00 !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
  }

  .header-button-delete:hover {
    color: #FFFFFF !important;
    background: #A51D00 !important;
  }

  .header-button-Take {
    width: 72px;
    height: 40px;
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF !important;
    background: #528BFF !important;
    border-radius: 12px;
  }

  .header-button-Take:hover {
    color: #FFFFFF !important;
    background: #528BFF !important;
  }

  .functionBlocks /deep/ .el-form-item__content{
    width: 100%;
    margin-left: 0!important;
  }

  .header-button-add {
    height: 40px;
    background: #FF7052 !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
    margin-bottom: 10px;
  }

  .header-button-add:hover {
    color: #FFFFFF !important;
    background: #FF7052 !important;
  }

  .header-button-save {
    height: 40px;
    background: #528BFF !important;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF !important;
  }

  .header-button-save:hover {
    color: #FFFFFF !important;
    background: #528BFF !important;
  }

  .header-button-order {
    height: 40px;
    background: #528BFF !important;
    border-radius: 12px;
    color: #FFFFFF !important;
    font-size: 16px;
    font-weight: 500;
  }

  .header-button-order:hover {
    color: #FFFFFF !important;
    background: #528BFF !important;
  }

  .my-step {
    padding-top: 63px;
  }

  /* 已完成title文字颜色 */
  .my-step /deep/ .is-finish {
    font-size: 16px;
    font-weight: 500;
    font-style: italic;
    color: #FF7052;
  }

  /* 进行中title文字颜色 */
  .my-step /deep/ .is-process {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #FF7052;
  }

  /* 等待中title文字颜色*/
  .my-step /deep/ .is-wait {
    font-size: 1rem;
    font-weight: 500;
    font-style: italic;
    color: #666666;
  }

  /* 圆圈数字颜色*/
  .my-step /deep/ .el-step__icon-inner {
    padding-right: 6px;
    font-size: 1.5rem;
    font-style: italic !important;
    font-weight: 800;
    color: #FFFFFF;
  }

  /* 圆圈数字颜色*/
  .my-step /deep/ .el-step__icon-inner:before {
    content: '0';
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-finish .is-text {
    background: #EB6F67 !important;
    border-color: #EB6F67 !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-process .is-text {
    background: #EB6F67 !important;
    border-color: #EB6F67 !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-text 圆圈颜色*/
  .my-step /deep/ .is-wait .is-text {
    background: #CCCCCC !important;
    border-color: #CCCCCC !important;
    width: 56px;
    height: 56px;
    margin-top: -45px;
  }

  /*is-finish 圆圈颜色*/
  .my-step /deep/ .el-steps.el-steps--horizontal {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;

  }

  .my-step /deep/ .el-step.is-horizontal.is-center {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;
  }

  .my-step /deep/ .el-step__head.is-finish {
    color: #EB6F67 !important;
    border-color: #EB6F67 !important;
  }

  /*is-process 圆圈颜色*/
  .my-step /deep/ .el-steps.el-steps--horizontal {
    color: #FF7052;
    border-color: #FF7052;
  }

  .my-step /deep/ .el-step__head.is-process {
    color: #FF7052;
    border-color: #FF7052;
  }

  .my-step /deep/ .el-step.is-horizontal.is-center {
    color: #FF7052;
    border-color: #FF7052;
  }

  /* 输入框去圆角 */
  .my-input /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 1rem;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: center !important;
  }

  /* 输入框文字左对齐 */
  .my-input-left /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }

  /* 必填框去掉*号 */
  .form-item-label /deep/ .el-form-item__label:before {
    color: #FFFFFF !important;
    margin-right: 0!important;
    content: '' !important;
  }

  .form-item-label /deep/ .el-form-item__label {
    font-size: 1rem !important;
    margin: 0 auto;
  }

  .specialTip{
    width: 1rem;
    height: 1rem;
    padding: 0;
    border-radius: 50%;
    border: 1px solid #F2613F;
    display: inline-block;
    text-align: center;
    font-size: .75rem;
    line-height: 10px;
    position: absolute;
    top: calc((40px - 1rem)/2);
    left: 165px;
  }
  .specialTip:before {
    width: 1rem;
    height: 1rem;
    content: '?';
    font-weight: bold;
    color: #F2613F;
  }

  .true{
    color: #FFFFFF!important;
    background-color: #f2613f!important;
    height: 40px;
    width: 144px;
    max-width: 640px;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }
  .false{
    height: 40px;
    width: 144px;
    max-width: 640px;
    background: #F7F7F7;
    margin: 0 5px 5px 10px;
    text-align: center;
    display: inline-block;
  }

  /* 输入框文字左对齐 */
  .true /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF!important;
    background-color: #f2613f!important;
    text-align: left !important;
  }

  /* 输入框文字左对齐 */
  .false /deep/ .el-input__inner {
    border: 0 !important;
    font-size: 16px;
    font-weight: 400;
    color: #333333 !important;
    background-color: #F7F7F7 !important;
    text-align: left !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/product/chinaLifeAccidentInsurance/insureManagement.vue